// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "tree-nav,tree-nav-subtree{display:block}", "",{"version":3,"sources":["webpack://./src/shared/framework/components/controls/navigation/tree-nav/tree-nav.scss"],"names":[],"mappings":"AAEA,0BAGC,aAAA","sourcesContent":["@import \"resources/index\";\r\n\r\ntree-nav,\r\ntree-nav-subtree\r\n{\r\n\tdisplay: block;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
